import {
    SEARCH_SET_ORDER,
    SEARCH_SET_ARTICLES,
    SEARCH_TOGGLE_ARTICLES_VIEW,
    SEARCH_SET_DISPLAYED_ARTICLES

} from '../Actions/Search.action';

const defaultState = {
    order: 'NAME_ASC',
    articles: [],
    displayedArticles: [],
    isArticlesShortView: true
}


export const search = (state = defaultState, { type, payload }) => {
    switch (type) {
        case SEARCH_SET_DISPLAYED_ARTICLES:
        case SEARCH_SET_ORDER:
        case SEARCH_SET_ARTICLES:
        case SEARCH_TOGGLE_ARTICLES_VIEW:
            return { ...state, ...payload }
        default:
            return state;
    }
}